import React from "react";
import {
  Box,
  Flex,
  Link,
  Text,
  useColorModeValue,
  Image,
  Button,
  HStack,
  IconButton,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { HamburgerIcon } from "@chakra-ui/icons";

/** Logo + desktop links + menu + auth. Drawer content lives in Navbar. */
const Header = ({ onOpenMenu = () => {} }) => {
  const barBg = useColorModeValue("rgba(239, 246, 255, 0.82)", "rgba(30, 41, 79, 0.85)");
  const borderBottom = useColorModeValue("blue.100", "whiteAlpha.200");
  const headerShadow = useColorModeValue("0 1px 3px rgba(0,0,0,0.06)", "0 2px 8px rgba(0,0,0,0.35)");
  const navHoverBg = useColorModeValue("gray.100", "whiteAlpha.200");
  const linkColor = useColorModeValue("gray.700", "gray.100");
  const brandNameColor = useColorModeValue("gray.900", "white");
  const navLinkStyles = {
    px: 2.5,
    py: 2,
    rounded: "md",
    fontSize: "sm",
    fontWeight: "600",
    color: linkColor,
    whiteSpace: "nowrap",
    _hover: { textDecoration: "none", bg: navHoverBg },
  };

  return (
    <Box
      bg={barBg}
      borderBottomWidth="1px"
      borderColor={borderBottom}
      position="sticky"
      top={0}
      zIndex={998}
      pl={{ base: "max(1rem, env(safe-area-inset-left, 0px))", md: 4 }}
      pr={{
        base: "max(0.75rem, env(safe-area-inset-right, 0px))",
        md: 6,
      }}
      pt={{
        base: "max(0.75rem, env(safe-area-inset-top, 0px))",
        md: 3,
      }}
      pb={3}
      boxShadow={headerShadow}
      backdropFilter="saturate(180%) blur(14px)"
      WebkitBackdropFilter="saturate(180%) blur(14px)"
    >
      <Flex align="center" justify="space-between" gap={3} wrap="nowrap" minH={{ md: "44px" }}>
        <Flex align="center" gap={{ base: 2, md: 3 }} minW={0} flexShrink={1}>
          <Link
            as={RouterLink}
            to="/"
            display="flex"
            alignItems="center"
            gap={{ base: 2, md: 2.5 }}
            textDecoration="none"
            flexShrink={1}
            minW={0}
            _hover={{ textDecoration: "none", opacity: 0.9 }}
          >
            <Image src="/logo.png" alt="" height="34px" width="auto" flexShrink={0} />
            <Text
              as="span"
              fontWeight="extrabold"
              fontSize={{ base: "0.9375rem", sm: "md", md: "lg" }}
              color={brandNameColor}
              lineHeight={1.1}
              letterSpacing="-0.02em"
              whiteSpace="nowrap"
              noOfLines={1}
            >
              Manage360.me
            </Text>
          </Link>

          <HStack spacing={1} display={{ base: "none", lg: "flex" }} pl={1}>
            <Link as={RouterLink} to={{ pathname: "/", hash: "features" }} {...navLinkStyles}>
              Product tour
            </Link>
            <Link as={RouterLink} to="/pricing" {...navLinkStyles}>
              Pricing
            </Link>
            <Link as={RouterLink} to="/contact-us" {...navLinkStyles}>
              Contact
            </Link>
          </HStack>
        </Flex>

        <HStack spacing={1} flexShrink={0}>
          <IconButton
            aria-label="Open navigation menu"
            icon={<HamburgerIcon boxSize={5} />}
            variant="ghost"
            size="md"
            onClick={onOpenMenu}
          />
          <Button as={RouterLink} to="/login" size="sm" variant="ghost" fontWeight="semibold">
            Sign in
          </Button>
          <Button as={RouterLink} to="/register" colorScheme="teal" size="sm" fontWeight="bold">
            Start free
          </Button>
        </HStack>
      </Flex>
    </Box>
  );
};

export default Header;
